export const config = {
  heading: "Get started",
  body: "To access relevant services and benefits, select your details below.",
  fields: {
    planProvider: {
      label: "Insurance carrier",
      placeholder: "Select insurance carrier",
    },
    plan: {
      label: "Insurance plan",
      placeholder: "Select insurance plan"
    },
    holder: {
      label: "Primary policyholder",
      placeholder: "Select primary policyholder",
      options: [
        { value: "SE", text: "Self" },
        { value: "SP", text: "Spouse" },
        { value: "PG", text: "Parent or guardian" },
      ]
    },
    office: {
      label: "Office location",
      placeholder: "Select office location",
      tooltip: "In order to change this setting, please contact your supervisor or administrator.",
    }
  },
  button: {
    text: "Submit Plan Details",
  },
}



// WEBPACK FOOTER //
// ./assets/common/components/PlanDetails/components/formConfig.js